/**
 * Created by admin on 2017/4/5.
 */
import { GetAgentOrderList, ERP_AgentFedBackAdd, LoadDataForAgentReceive, StockOutReceive } from '../../api/agentApi';
import NProgress from 'nprogress'
import browserMD5File from 'browser-md5-file'
import {
    util
} from '../../common/js/util.js';
import uploader from '../../lib/plupload-2.1.2/js/plupload.dev.js'
import { GetParmConfig } from '../../api/commonApi.js'
module.exports = {
    data() {
        return {
            queryType: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "正常", "TypeValue": "1" }, { "TypeName": "已作废", "TypeValue": "3" }],
            queryDelivery: [{ "TypeName": "-请选择-", "TypeValue": "-1" }, { "TypeName": "待收货", "TypeValue": "1" }, { "TypeName": "已收货(正常)", "TypeValue": "2" }, { "TypeName": "已收货(异常)", "TypeValue": "3" }, { "TypeName": "已反馈(正常)", "TypeValue": "4" }, { "TypeName": "已反馈(异常)", "TypeValue": "5" }],
            feedbackCheckView: false,
            reGoods: {
                "StockOutId": "",
                "GoodsList": [{
                    "ProId": 0,
                    "ProNum": 0
                }],
                "GiftsList": [{
                    "ProId": 0,
                    "ProNum": 0
                }]
            },
            fullPicture: false,
            fullPicture2: false,

            PictureList: [],
            otherPictureList: [],
            QueryTypeList: [],
            flag1: "1",
            flag2: "1",
            logining: false,
            AddForm: {
                "StockOutId": "",
                "SignImg": [],
                "OtherImg": [],
                "CustomerRemark": "",
                "ReceiveType": ""
            },
            hideHeader: false,
            /*----------------*/
            loading2: false,
            lists: [],
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            sels: [], //列表选中�?
            SaleCheckView: false,
            pageSizes: [10, 20, 50],
            GoodsList: {},
            query: {
                OutCode: "",
                OrderCode: "",
                SendCode: "",
                AgentName: "",
                AreaName: "",
                LogCode: "",
                Status: "",
                ReceivingStatus: "",
                BusUser: ""
            }
        }
    },
    methods: {
        sumbitGoods() {

            this.reGoods.GoodsList = [];
            this.reGoods.GiftsList = [];
            if (this.GoodsList.ListGoods.length > 0) {
                for (var i = 0; i < this.GoodsList.ListGoods.length; i++) {
                    var a = {};
                    a.ProId = this.GoodsList.ListGoods[i].ProId;
                    a.ProNum = this.GoodsList.ListGoods[i].ProNum;
                    this.reGoods.GoodsList.push(a)
                }
            }
            if (this.GoodsList.GiftGoods.length > 0) {
                for (var i = 0; i < this.GoodsList.GiftGoods.length; i++) {
                    var a = {};
                    a.ProId = this.GoodsList.GiftGoods[i].ProId;
                    a.ProNum = this.GoodsList.GiftGoods[i].ProNum;
                    this.reGoods.GiftsList.push(a)
                }
            }
            /*StockOutReceive*/
            StockOutReceive(this.reGoods).then(res => {
                util.doResult(this, res,
                    () => {
                        this.List();
                        this.SaleCheckView = false;
                    });
            });
        },
        feedBackSubmit() {
            this.AddForm.SignImg = this.PictureList;
            this.AddForm.OtherImg = this.otherPictureList;
            ERP_AgentFedBackAdd(this.AddForm).then(res => {
                util.doResult(this, res,
                    () => {
                        this.$notify({
                            title: '成功',
                            message: "反馈提交成功",
                            type: 'success'
                        });
                        this.List();
                        this.feedbackCheckView = false;
                    });
            });
        },
        feedback(item) {
            this.AddForm = {
                "StockOutId": item.StockOutId,
                "SignImg": [],
                "OtherImg": [],
                "CustomerRemark": "",
                "ReceiveType": ""
            };
            this.PictureList = [];
            this.otherPictureList = [];
            this.feedbackCheckView = true;
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                ParmType: "11"
            };
            GetParmConfig(para).then(res => {
                util.doResult(this, res,
                    () => {
                        this.QueryTypeList = res.data.Data;
                    });
            });

            var _this = this; //指向upload实例
            this.$nextTick(function() {
                var accessid = 'wKoXc1dyT1cYDBPN';
                var accesskey = 'LeXHaVXwKFppzaBywBeA4tVKVNEJ6s';
                var host = 'http://zqres.oss-cn-hangzhou.aliyuncs.com';

                var time = new Date(),
                    timestamp, suffix;
                var d = time.getFullYear() + "/" + (time.getMonth() + 1) + "/" + time.getDate() + '/';
                var g_dirname = 'webapires/ol/' + d;
                var g_object_name = '';
                var g_object_name_type = 'random_name';
                var g_ali_dirname = 'http://resimg.iqeq01.com/';
                var now = timestamp = Date.parse(time) / 1000;

                var policyText = {
                    "expiration": "2050-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件�?
                    "conditions": [
                        ["content-length-range", 0, 1048576000] // 设置上传文件的大小限�?
                    ]
                };
                var policyBase64 = Base64.encode(JSON.stringify(policyText))
                window.message = policyBase64
                var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
                    asBytes: true
                });
                var signature = Crypto.util.bytesToBase64(bytes);
                /*----------------*/

                var arr = {
                    Name: '',
                    Url: '',
                }
                const uploader1 = new plupload.Uploader({
                    runtimes: 'html5,flash,silverlight,html4',
                    browse_button: 'btn1',
                    multi_selection: false,
                    container: document.getElementById('container1'),
                    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                    url: 'http://oss.aliyuncs.com',
                    filters: {
                        mime_types: [ //只允许上传图片和zip文件
                            {
                                title: "Image files",
                                extensions: "jpg,gif,png"
                            },
                        ],
                        max_file_size: '204800kb',
                    },
                    init: {
                        PostInit: function(up, files) {

                        },

                        FilesAdded: function(up, files) {

                            plupload.each(files, function(file) {
                                //_this.TeachingPlanName = file.name
                                // document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b><a href="javascript:void(0);" id="del">删除</a>'
                                // +'<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                // +'</div>';
                            });
                            up.start();
                        },


                        BeforeUpload: function(up, file) {
                            var len = len || 32;
                            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                            var maxPos = chars.length;
                            var pwd = '';
                            for (var i = 0; i < len; i++) {
                                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                            }
                            var pos = file.name.lastIndexOf('.')
                            suffix = ''
                            if (pos != -1) {
                                suffix = file.name.substring(pos)
                            }
                            g_object_name = g_dirname + pwd + suffix;
                            var new_multipart_params = {
                                'key': g_object_name,
                                'policy': policyBase64,
                                'OSSAccessKeyId': accessid,
                                'success_action_status': '200', //让服务端返回200,不然，默认会返回204
                                'signature': signature,
                            };
                            up.setOption({
                                'url': host,
                                'multipart_params': new_multipart_params
                            });

                        },
                        UploadProgress: function(up, file) {
                            _this.logining = true;
                            up.disableBrowse(true)
                        },
                        FileUploaded: function(up, file, info) {

                            if (info.status == 200) {
                                /*_this.$message({
                                 showClose: true,
                                 message: '上传成功'
                                 });*/
                                _this.logining = false;
                                arr.Name = file.name;
                                arr.Url = g_ali_dirname + g_object_name;
                                _this.PictureList.push(arr);
                                arr = {
                                    Name: '',
                                    Url: '',
                                }
                                up.disableBrowse(false)
                            } else {

                            }
                        },
                        Error: function(up, err) {
                            if (err.code == -600) {
                                _this.$message.error('文件大小不符合规范');
                            } else {
                                _this.$message.error(err.message);
                            }
                        }
                    }
                });

                if (_this.flag1 == '1') {
                    _this.flag1 = ''
                    uploader1.init()
                }
                /*------------------*/

            })
            this.$nextTick(function() {
                var accessid = 'wKoXc1dyT1cYDBPN';
                var accesskey = 'LeXHaVXwKFppzaBywBeA4tVKVNEJ6s';
                var host = 'http://zqres.oss-cn-hangzhou.aliyuncs.com';

                var time = new Date(),
                    timestamp, suffix;
                var d = time.getFullYear() + "/" + (time.getMonth() + 1) + "/" + time.getDate() + '/';
                var g_dirname = 'webapires/ol/' + d;
                var g_object_name = '';
                var g_object_name_type = 'random_name';
                var g_ali_dirname = 'http://resimg.iqeq01.com/';
                var now = timestamp = Date.parse(time) / 1000;

                var policyText = {
                    "expiration": "2050-01-01T12:00:00.000Z",
                    "conditions": [
                        ["content-length-range", 0, 1048576000]
                    ]
                };
                var policyBase64 = Base64.encode(JSON.stringify(policyText))
                window.message = policyBase64
                var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, {
                    asBytes: true
                });
                var signature = Crypto.util.bytesToBase64(bytes);
                var arr = {
                    Name: '',
                    Url: '',
                }
                const uploader2 = new plupload.Uploader({
                    runtimes: 'html5,flash,silverlight,html4',
                    browse_button: 'btn2',
                    multi_selection: false,
                    container: document.getElementById('container2'),
                    flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
                    silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
                    url: 'http://oss.aliyuncs.com',
                    filters: {
                        mime_types: [ //只允许上传图片和zip文件
                            {
                                title: "Image files",
                                extensions: "jpg,gif,png"
                            },
                        ],
                        max_file_size: '204800kb',
                    },
                    init: {
                        PostInit: function(up, files) {},

                        FilesAdded: function(up, files) {

                            plupload.each(files, function(file) {
                                //_this.TeachingPlanName = file.name
                                // document.getElementById('ossfile').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b><a href="javascript:void(0);" id="del">删除</a>'
                                // +'<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>'
                                // +'</div>';
                            });
                            up.start();
                        },


                        BeforeUpload: function(up, file) {
                            var len = len || 32;
                            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                            var maxPos = chars.length;
                            var pwd = '';
                            for (var i = 0; i < len; i++) {
                                pwd += chars.charAt(Math.floor(Math.random() * maxPos));
                            }
                            var pos = file.name.lastIndexOf('.')
                            suffix = ''
                            if (pos != -1) {
                                suffix = file.name.substring(pos)
                            }
                            g_object_name = g_dirname + pwd + suffix;
                            var new_multipart_params = {
                                'key': g_object_name,
                                'policy': policyBase64,
                                'OSSAccessKeyId': accessid,
                                'success_action_status': '200',
                                'signature': signature,
                            };
                            up.setOption({
                                'url': host,
                                'multipart_params': new_multipart_params
                            });

                        },
                        UploadProgress: function(up, file) {
                            _this.logining = true;
                            up.disableBrowse(true)
                        },
                        FileUploaded: function(up, file, info) {
                            if (info.status == 200) {
                                /*_this.$message({
                                 showClose: true,
                                 message: '上传成功'
                                 });*/
                                _this.logining = false;
                                arr.Name = file.name;
                                arr.Url = g_ali_dirname + g_object_name;
                                _this.otherPictureList.push(arr);
                                arr = {
                                    Name: '',
                                    Url: '',
                                }
                                up.disableBrowse(false)
                            } else {

                            }
                        },
                        Error: function(up, err) {
                            if (err.code == -600) {
                                _this.$message.error('文件大小不符合规范');
                            } else {
                                _this.$message.error(err.message);
                            }
                        }
                    }
                });

                if (_this.flag2 == '1') {
                    _this.flag2 = ''
                    uploader2.init()
                }
                /*------------------*/

            })
        },
        harvest(item) {
            this.reGoods.StockOutId = item.StockOutId;
            this.SaleCheckView = true;
            this.reGoods.StockOutId = item.StockOutId;
            let _session = util.getSessin();
            let para = {
                Sid: _session[0],
                Session: _session[1],
                StockOutId: item.StockOutId
            };
            LoadDataForAgentReceive(para).then(res => {
                util.doResult(this, res,
                    () => {
                        var a = res.data.Data;
                        if (a.ListGoods.length > 0) {
                            for (var i = 0; i < a.ListGoods.length; i++) {
                                a.ListGoods[i].ProNum = a.ListGoods[i].ActualNum;
                            }
                        }
                        if (a.GiftGoods.length > 0) {
                            for (var i = 0; i < a.GiftGoods.length; i++) {
                                a.GiftGoods[i].ProNum = a.GiftGoods[i].ActualNum;
                            }
                        }
                        if (a.GiftGoods.length > 0) {
                            this.showGiftGoods = true
                        }
                        this.GoodsList = a;
                    });
            });
        },
        addOrder: function() {
            this.$router.push("/Order/SaleOrder/addOrder");
        },
        delPicture(Url, type) {
            if (type == 'del') {
                if (this.otherPictureList.length > 0) {
                    for (var i = 0; i < this.otherPictureList.length; i++) {
                        if (this.otherPictureList[i].Url == Url) {
                            this.otherPictureList.splice(i, 1)
                        }
                    }
                }

            } else {
                if (this.PictureList.length > 0) {
                    for (var i = 0; i < this.PictureList.length; i++) {
                        if (this.PictureList[i].Url == Url) {
                            this.PictureList.splice(i, 1)
                        }
                    }
                }

            }

        },
        viewPicture(Url) {
            window.open(Url)
        },
        List() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显�?
            var para = this.getParams()
            GetAgentOrderList(para).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt)
            });
        },
        getParams: function() {
            var para = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                orderBy: this.orderBy
            };
            if (this.query.OrderCode != '') {
                para.OrderCode = this.query.OrderCode
            }
            if (this.query.SendCode != '') {
                para.SendCode = this.query.SendCode
            }
            if (this.query.AgentName != '') {
                para.AgentName = this.query.AgentName
            }
            if (this.query.AreaName != '') {
                para.AreaName = this.query.AreaName
            }
            if (this.query.Status != '') {
                para.Status = this.query.Status
            }
            if (this.query.DeliveryStatus != '') {
                para.DeliveryStatus = this.query.DeliveryStatus
            }
            if (this.query.BusUser != '') {
                para.BusUser = this.query.BusUser
            }
            if (this.query.LogCode != '') {
                para.LogCode = this.query.LogCode
            }
            if (this.query.OutCode != '') {
                para.OutCode = this.query.OutCode
            }
            if (this.query.ReceivingStatus != '') {
                para.ReceivingStatus = this.query.ReceivingStatus
            }

            return para
        },
        outTips: function(StateCode, StateMsg, Data, Cnt) {
            if (StateCode !== 0 && StateCode !== 99) {
                this.$notify({
                    title: '错误',
                    message: StateMsg,
                    type: 'error'
                });
            } else {
                this.totalSize = Cnt;
                this.loading2 = false; //拼命加载中隐�?
                this.lists = Data;
            }
        },
        selsChange: function(sels) {
            this.sels = sels;
        },
        onQuerySubmit: function() {
            this.pageIndex = 1;
            this.lists = [];
            this.loading2 = true;
            var para = this.getParams()
            GetAgentOrderList(para).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt)
            });
        }, //查询功能
        handleSizeChange: function(val) {
            this.pageSize = val;
            this.List();
        },
        //查询单条
        handleView: function(index, row) {
            util.redirect(this, "/AgentOrder/AgentOrder/viewAgentOrder?Id=" + row.StockOutId, false)

        }, //编辑功能
        onQueryClean: function() {
            this.query.OrderCode = "";
            this.query.SendCode = "";
            this.query.AgentName = "";
            this.query.AreaName = "";
            this.query.Status = "";
            this.query.DeliveryStatus = "";
            this.query.BusUser = "";


            this.query.LogCode = "";
            this.query.OutCode = "";
            this.query.ReceivingStatus = "";

            this.List();
        },
        //删除
        handleDel: function() {
            var ids = this.sels.map(item => item.OrderId).toString();
            if (ids == "") {
                this.$notify({
                    title: '提示',
                    message: '还没有择删除内容',
                    type: 'warning'
                })
                return
            } else {
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    NProgress.start();
                    let para = { Ids: ids };
                    ERP_OrderDel(para).then((response) => {
                        NProgress.done();
                        if (response.data.StateCode !== 0) {
                            this.$notify({
                                title: '错误',
                                message: response.data.StateMsg,
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success'
                            });
                            this.List();
                        }
                    });
                }).catch(() => {

                });

            }
        },
        //下载文件
        download: function() {
            this.$confirm('确认导出吗？', '提示', {}).then(() => {
                this.List();
                var para = this.getParams()
                GetOrderExport(para).then(res => {
                    util.doResult(this, res, () => {});
                    let { StateCode, StateMsg, Data, Cnt } = res.data;
                    if (StateCode !== 0 && StateCode !== 99) {
                        this.$notify({
                            title: '错误',
                            message: StateMsg,
                            type: 'error'
                        });
                    } else {

                        try {

                            var elemIF = document.createElement("iframe");
                            elemIF.src = Data;
                            elemIF.style.display = "none";
                            document.body.appendChild(elemIF);
                        } catch (e) {
                            this.$notify({
                                title: '浏览器不兼容，建议使用谷歌浏览器',
                                type: 'error'
                            });
                        }
                    }
                });

            })
        }, //导出功能
        handleCurrentChange: function(val) {
            this.pageIndex = val;
            this.lists = [];
            this.loading2 = true; //拼命加载中显�?
            var para = this.getParams()
            GetAgentOrderList(para).then(res => {
                util.doResult(this, res, () => {});
                let { StateCode, StateMsg, Data, Cnt } = res.data;
                this.outTips(StateCode, StateMsg, Data, Cnt)
            });
        }
    },
    watch: {
        otherPictureList: function() {
            if (this.otherPictureList.length == 9) {
                this.fullPicture = true;
                this.$notify({
                    title: '提示',
                    message: "最多只能上传9张图片，当前已达上限",
                    type: 'info'
                });
            } else {
                this.fullPicture = false;
            }

        },
        PictureList: function() {
            if (this.PictureList.length == 9) {
                this.fullPicture2 = true;
                this.$notify({
                    title: '提示',
                    message: "最多只能上传9张图片，当前已达上限",
                    type: 'info'
                });
            } else {
                this.fullPicture2 = false;
            }

        },
    },
    created() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.sysUserName = user.RealName || '';
            this.sysSid = user.Sid || '';
            this.sysSession = user.Session || '';
            this.sysUserAvatar = user.avatar || '';
        }
        this.List();

    }
}


// WEBPACK FOOTER //
// ./src/pages/Agent/AgentOrder.js